import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubDivision } from 'src/app/wings-mobile/models/subDivision/sub-division.model';
import { environment } from 'src/environments/environment';
import { Filter } from '../../models/filter/Filter';

@Injectable({
	providedIn: 'root'
})
export class SubDivisionService {

	constructor(private http: HttpClient) {
	}

	getSubDivisionId(country: string): Observable<SubDivision> {
		const url = environment.backend_url + `/api/v1/subdivision/${country}`

		return this.http.get<SubDivision>(url);
	}

	getAllSubdivisions() {
		const url = environment.backend_url + '/api/v1/filters/allSubdivisions';
		return this.http.get<Filter[]>(url);
	}
}
